/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryGa4RevenueCurrencyData
 */
export interface GoogleBigQueryGa4RevenueCurrencyData {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4RevenueCurrencyData
     */
    currency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryGa4RevenueCurrencyData
     */
    purchaseRevenue?: string;
}

/**
 * Check if a given object implements the GoogleBigQueryGa4RevenueCurrencyData interface.
 */
export function instanceOfGoogleBigQueryGa4RevenueCurrencyData(value: object): value is GoogleBigQueryGa4RevenueCurrencyData {
    return true;
}

export function GoogleBigQueryGa4RevenueCurrencyDataFromJSON(json: any): GoogleBigQueryGa4RevenueCurrencyData {
    return GoogleBigQueryGa4RevenueCurrencyDataFromJSONTyped(json, false);
}

export function GoogleBigQueryGa4RevenueCurrencyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryGa4RevenueCurrencyData {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] === undefined ? undefined : json['currency'] === null ? null : json['currency'],
        'purchaseRevenue': json['purchaseRevenue'] == null ? undefined : json['purchaseRevenue'],
    };
}

export function GoogleBigQueryGa4RevenueCurrencyDataToJSON(json: any): GoogleBigQueryGa4RevenueCurrencyData {
    return GoogleBigQueryGa4RevenueCurrencyDataToJSONTyped(json, false);
}

export function GoogleBigQueryGa4RevenueCurrencyDataToJSONTyped(value?: GoogleBigQueryGa4RevenueCurrencyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'purchaseRevenue': value['purchaseRevenue'],
    };
}

